export const TRIP_EDITOR_DRAFT_PREFIXES = ['roam:stop-editor:', 'roam:proposal-suggest:'];

/** Never adopt legacy drafts whose author is unknown, or persist before auth resolves. */
export function accountDraftKey(prefix: string, userId: string | undefined, ...ids: string[]) {
  return userId ? `${prefix}v2:${JSON.stringify([userId, ...ids])}` : null;
}

export function clearTripEditorDrafts() {
  if (typeof window === 'undefined') return;
  try {
    for (let i = window.sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = window.sessionStorage.key(i);
      if (key && TRIP_EDITOR_DRAFT_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        window.sessionStorage.removeItem(key);
      }
    }
  } catch {
    // Storage can be unavailable in restricted WebViews.
  }
}
